import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import classNames from 'classnames';
import styled from 'styled-components';

import { FullWidthContainer } from '@sorare/core/src/atoms/layout/FullWidthContainer';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { useIsMobileApp } from '@sorare/core/src/hooks/useIsMobileApp';

import { CommonPacksPage as NewCommonPacksPage } from '@sorare/marketplace/src/components/commonCard/CommonPacksPage';
import { SearchParamBasedBuyGemsDialog } from '@sorare/marketplace/src/components/commonCard/SearchParamBasedBuyGemsDialog';

import type {
  CommonPacks_marketRoot,
  CommonPacks_tokenRoot,
} from './__generated__/index.graphql';

const Wrapper = styled(Vertical).attrs({ gap: 6 })`
  padding-bottom: var(--double-unit);
  container-type: inline-size;
  &.isMobileApp {
    padding-bottom: calc(8 * var(--unit));
  }
`;

type Props = {
  marketRoot?: CommonPacks_marketRoot;
  tokenRoot?: CommonPacks_tokenRoot;
  refetch: () => Promise<unknown>;
};

export const CommonPacks = ({ marketRoot, tokenRoot, refetch }: Props) => {
  const { isMobileApp } = useIsMobileApp();
  if (!marketRoot || !tokenRoot) {
    return null;
  }

  return (
    <>
      <Wrapper
        className={classNames({
          isMobileApp,
        })}
      >
        <FullWidthContainer.NoPadding>
          <NewCommonPacksPage
            refetch={refetch}
            marketRoot={marketRoot}
            tokenRoot={tokenRoot}
          />
        </FullWidthContainer.NoPadding>
      </Wrapper>
      <SearchParamBasedBuyGemsDialog />
    </>
  );
};

CommonPacks.fragments = {
  marketRoot: gql`
    fragment CommonPacks_marketRoot on MarketRoot {
      id
      ...CommonPacksPage_marketRoot
    }
    ${NewCommonPacksPage.fragments.marketRoot}
  ` as TypedDocumentNode<CommonPacks_marketRoot>,
  tokenRoot: gql`
    fragment CommonPacks_tokenRoot on TokenRoot {
      ...CommonPacksPage_tokenRoot
    }
    ${NewCommonPacksPage.fragments.tokenRoot}
  ` as TypedDocumentNode<CommonPacks_tokenRoot>,
};
